import { useAtomValue, useSetAtom } from "jotai";
import { loadable } from "jotai/utils";
import { useCallback } from "react";

import type { TemplateOnboardingConfig } from "../../internal/document/template-onboarding.types";
import {
	$saveTemplateConfig,
	$templateConfig,
} from "../../internal/templates/template-config.atom";

/**
 * Hook to read and write the template config (prompts) for a document.
 */
export const useTemplateConfig = (documentId: string | undefined) => {
	const configLoadable = useAtomValue(loadable($templateConfig(documentId)));
	const config = configLoadable.state === "hasData" ? configLoadable.data : null;
	const isLoading = configLoadable.state === "loading";

	const saveConfigAtom = useSetAtom($saveTemplateConfig);

	const saveConfig = useCallback(
		async (newConfig: TemplateOnboardingConfig) => {
			if (!documentId) {
				return;
			}
			await saveConfigAtom({ documentId, config: newConfig });
		},
		[documentId, saveConfigAtom]
	);

	return { config, isLoading, saveConfig };
};
